import { h, Component } from 'preact';
import { Loading, Error } from 'lib/mkjs';
import ContactEntity from "entities/contactentity";
import ContactInfo from "entities/contactinfo";
import ConnectionRequest from "entities/connectionrequest";
import style from './style.less';

class ConnectionRequestList extends ConnectionRequest {

	constructor(props = {}, {shouldRefetch} = {}) {
		super(props, {shouldRefetch});
		const inheritedOnupdate = this.state.onUpdate;
		this.state.onUpdate = (subject)=>{
			this.fetchSubject(); //this will update this list when an item in the list is updated (deletions are not allowed in this view)
			if (inheritedOnupdate) {
				inheritedOnupdate(subject); //this will update the list (to include any accepted connections) and update the specials (to show badge changes)
			}
		}
	}

	getName() {
		return 'connectionRequest';
	}

	getListParams() {
		return {
			'requestee.id': this.props.contactEntity.id,
			'status': 'ACTIVE'
		};
	}

	renderListPage(list) {
		//override this from listable to remove standard header
		return list.length
		? <section class="my-2">
				<h2>Connection Requests</h2>
				{this.renderList(list, {hideNumber: true})}
			</section>
		: ''
	}

	getListFields(list) {
		//fields: requestor (with image and name), requesteeIdentifier, ignore/accept actions
		return {
			requestor: {
				valueFunc: (requestor,request)=>{
					return (requestor.contactInfo && requestor.contactInfo.info && requestor.contactInfo.info.name) || 'Addy member';//TODO add other info
				}
			},
			foundYouVia: {
				valueFunc: (_,request)=>request.requesteeIdentifier
			}
		}
		return super.getListFields(list);
	}

	getActions(item, isEmbedded) {
		return {
			accept:(obj) => {
				return this.renderListButton('check', (e)=>{
					return this.submitUpdate(obj.id, {
						status: 'ACCEPTED'
					})
				});
			},
			ignore:(obj) => {
				return this.renderListButton('trash', (e)=>{
					return this.submitUpdate(obj.id, {
						status: 'IGNORED'
					})
				});
			}
		};
	}

}

export default class AddressBook extends ContactInfo {

	getName() {
		return 'contactInfo';
	}

	fetchList() {
		//TODO error checking
		let id = this.props.contactEntity.id;
		return this.props.apis.contactEntity.get(id + '/address-book')
	}

	onUpdate() {
		this.fetchSubject();
		this.props.refreshSpecials()
	}

	renderListPage(list) {
		//override this from listable to remove standard header
		//TODO add search/filter bar
		//TODO allow filter to personal-contacts-on-addy
		return <div>
			<section class="my-2">
				<div class="pull-right pt-2">
					<a class={"btn btn-info " + style.header_button} title="create new contact" href="/create">{this.addButtonContent()}</a>
					<a class={"btn btn-info ml-1 " + style.header_button} href="/import">{this.importButtonContent()}</a>
				</div>
				<ConnectionRequestList {...this.props} onUpdate={()=>this.onUpdate()} listing />
				<h2>My Contacts</h2>
				{ (list && list.length) ? this.renderList(list, {}) : this.renderEmpty() }
			</section>
		</div>
	}

	renderEmpty() {
		return <section class="my-5 mx-4 text-center">
			<h4>You don't have any contacts yet!</h4>
			<p>Import your contacts by clicking the <b>{this.importButtonContent()}</b> button above.</p>
			<p>or add contacts one-at-a-time by clicking the <b>{this.addButtonContent()}</b> button.</p>
		</section>
	}

	importButtonContent() {
		return "import..."
	}

	addButtonContent() {
			return "add"
	}

	renderList(list, opts) {
		return <div class={style.address_book_list}>
			{list.map(connectionView=>this.renderListItem(connectionView))}
		</div>
	}

	renderListItemIcon(subject) {
		return <span class={style.address_book_list_entry_icon}></span>
	}

	renderListItemLabel(connectionView) {
		const name = connectionView.name ? connectionView.name : '(no name)';
		return <span class={style.address_book_list_entry_label}>{name}</span>
	}

	renderListItemDecoration(connectionView) {
		//TODO add ellipse to every entry? we could include 'send request; delete; disconnect; view; edit'
		/*
		if connected: delete; disconnect; view; edit
		if is on site and not connected: delete; connect; view; edit
		if unknown/not on site and not connected: delete; send connection; view; edit
		if you requested connection...
		if they requested connection...
		*/
		let content;
		if (connectionView.connection){
			content = <span class={style.decoration_connected}><i title="connected" class="fa fa-handshake-o" aria-hidden="true"></i></span>
		} else if (this.props.specialCases) {
			let id = connectionView.personalContactInfo && connectionView.personalContactInfo.id;
			if (id in this.props.specialCases.infoDetails) {
				let details = this.props.specialCases.infoDetails[id];
				if (details.connectionRequestReceived) {
					//TODO show accept/ignore buttons
				} else if (details.connectionRequestSent) {
					//show request sent icon
					content = <span class={style.decoration_connected}><i class="fa fa-send-o" aria-hidden="true"></i></span>
				} else if (details.identitiesOnAddy.length) {
					//show request button
					content = this.renderRequestButton(id, details)
				}
			}
		}
		return <div class={style.address_book_list_entry_decoration}>{content}</div>
	}

	renderRequestButton(id, details) {

		let styles = "btn btn-info " + style.decoration_connect_button;
		let requestConnection = (e)=>{
			//TODO change button to loading icon
			let cr = {
				requestor: {
					id: this.props.contactEntity.id
				},
				personalContactCausingRequest: {
					id: id
				},
				requesteeIdentifier: details.identitiesOnAddy[0],
				desire: "CONNECTION"
			}
			//TODO update state to reflect requested
			this.props.apis.connectionRequest.create(cr).then(resp => {
				this.setState({
					isLoading: false,
				});
				console.log('connection request created', resp);
				this.onUpdate();
			}).catch(error => {
				//TODO put error in modal
				this.handleError(error);
			});
		}
		return <button class={styles} onClick={requestConnection}><i class="fa fa-plus" aria-hidden="true"></i></button>
	}

	renderListItem(connectionView) {
		return <div class={style.address_book_list_entry_container}>
			<a href={contactInfoUrl(connectionView)} class={style.address_book_list_entry}>
				{this.renderListItemIcon(connectionView)}
				{this.renderListItemLabel(connectionView)}
			</a>
			{this.renderListItemDecoration(connectionView)}
		</div>
	}

}

export function contactInfoUrl(connectionView) {
	if (connectionView.connection) {
		return '/connections/' + connectionView.connection.id
	} else {
		return '/contacts/' + connectionView.personalContactInfo.id;
	}
}

export class ContactListPage extends Component {
	render() {
		if (this.props.contactEntity) {
			return <AddressBookSpecialLoader {...this.props} />
		} else if (this.props.contactEntity === false) {
			return <Error message="You do not have a contact entity associated with your account." />
		} else {
			return <Loading />
		}
	}
}

export class AddressBookSpecialLoader extends ContactEntity {
	getName() {
		return 'contactEntity';
	}

	fetch() {
		return this.getApi().get(this.props.contactEntity.id + "/address-book-updates")
	}

	renderView(subject) {
		return <AddressBook {...this.props} refreshSpecials={()=>this.fetchSubject()} specialCases={subject} listing />
		//TODO add ConnectionRequestList at top
	}
}



// WEBPACK FOOTER //
// ./components/elements/addressbook/index.js